'use client';

import { H } from "highlight.run";
import { useEffect } from "react";
import { AppError } from "~/components/AppError";
import { env } from "~/env.mjs";
import { useTranslation } from "~/i18n/useTranslation";

export default function GlobalError({
    error,
    reset,
  }: {
    error: Error
    reset: () => void
}) {
    const { t } = useTranslation()
    useEffect(() => {
        if (env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
            H.consumeError(error)
        }
    }, [error])
    return (
        <html>
            <body>
                <AppError>
                    <button type='button' className='bg-primary-500 text-white px-3 py-1 flex space-x-3 rounded-md items-center justify-center' onClick={() => { reset(); window.location.reload(); }}>{t('action.retry')}</button>
                </AppError>
            </body>
        </html>
    )
}